import React from "react";
import {
  RootContainer,
  TitleContainer,
  DefaultBody,
  BodyText,
  DateTimeText,
  TitleContainerElements,
} from "./styles";
import {
  FlexSpace,
  HorizontalSpace,
  VerticalSpace,
} from "elements/Space/space";
import {
  sourceLocation,
  blackRightArrow,
  greenDestinationLocation,
  rightArrow,
  whiteRightArrowExtended,
} from "assets/icons";

const TripList = (props) => {
  const {
    data: { tripNo, distance, tripStatus, routeDetails },
    handleIsSelected,
    selected,
    index,
  } = props;

  const totalStops = routeDetails?.routeStops?.totalStops || "0";
  const stoppages = routeDetails?.routeStops?.stoppages || [];
  const sourceArea = stoppages[0]?.area || "Unknown Source";
  const destinationArea = stoppages.length > 0
    ? stoppages[stoppages.length - 1]?.area
    : "Unknown Destination";

  return (
    <RootContainer
      selected={selected === index ? true : false}
      onClick={() => handleIsSelected(index, routeDetails, tripStatus)}
    >
      <TitleContainer>
        <TitleContainerElements
          selected={selected === index ? true : false}
          inprogress={false}
        >{`Trip ${tripNo} - Stops(${totalStops})`}</TitleContainerElements>
        <HorizontalSpace count={2} />
        <TitleContainerElements
          selected={selected === index ? true : false}
          inprogress={tripStatus === "In Progress" ? true : false}
        >
          {tripStatus}
        </TitleContainerElements>
      </TitleContainer>
      <VerticalSpace count={2} />

      <DefaultBody>
        <img src={sourceLocation} />
        <HorizontalSpace count={0.5} />
        <BodyText expanded={true} source={true}>
          {sourceArea}
        </BodyText>
        <HorizontalSpace count={1} />
        <img src={whiteRightArrowExtended} />
        <HorizontalSpace count={2} />
        <img src={greenDestinationLocation} />
        <HorizontalSpace count={0.5} />
        <BodyText expanded={true} source={false}>
          {destinationArea}
        </BodyText>
        <FlexSpace />
        <DateTimeText>
          {selected === index ? (
            <img src={rightArrow} />
          ) : (
            <img src={blackRightArrow} />
          )}
        </DateTimeText>
      </DefaultBody>
      <VerticalSpace count={2} />
      <DateTimeText>Distance - {distance}</DateTimeText>
    </RootContainer>
  );
};

export default TripList;
